import styled from 'styled-components';
import {Color} from '../tokens/colors';
import {Radius} from '../tokens/radiuses';
import {Transition} from '../tokens/transitions';
import {Shadow} from '../tokens/shadows';
import Select from 'react-dropdown-select';

const StyledLabel = styled.label`
    position: relative;
    display: inline-block;
    align-self: flex-start;
    margin-bottom: 0;
    padding-right: 20px;
    font-weight: 400;
    font-size: 12px;
    line-height: 1.33;
    color: ${Color.TEXT_GRAY};
    cursor: pointer;
`;

const StyledLabelTip = styled.span`
    position: absolute;
    width: 20px;
    height: 15px;
    padding-left: 6px;
    padding-top: 1px;
    color: ${Color.PRIMARY_BLUE};
    cursor: pointer;

    &:hover,
    &:focus {
        span {
            display: block;
        }
    }

    span {
        position: absolute;
        left: 100%;
        top: 50%;
        display: none;
        padding: 8px;
        width: 182px;
        color: ${Color.BLACK};
        background-color: ${Color.WHITE};
        box-shadow: ${Shadow.BLOCK};
        transform: translate(0px, -50%);
    }

    a {
        padding-top: 4px;
        white-space: nowrap;
        display: inline-block;
    }
`;

const StyledInput = styled.input`
    &&& {
        appearance: none;
        width: 100%;
        padding: 12px 14px;
        font-weight: 400;
        font-size: 13px;
        line-height: 1;
        color: ${Color.BLACK};
        background-color: ${Color.WHITE};
        border: 1px solid ${Color.ICON_GRAY};
        border-radius: ${Radius.BUTTON};
        transition: border-color ${Transition.BUTTON};

        &:hover {
            border-color: ${Color.ICON_GRAY_HOVER};
        }

        &:focus {
            border-color: ${Color.BLACK};
        }

        &:disabled {
            color: ${Color.TEXT_GRAY};
            cursor: not-allowed;
        }
    }
`;

const StyledTextarea = styled.textarea`
    appearance: none;
    resize: none;
    width: 100%;
    height: 80px;
    padding: 12px 14px;
    font-weight: 400;
    font-size: 13px;
    line-height: 1;
    color: ${Color.BLACK};
    background-color: ${Color.WHITE};
    border: 1px solid ${Color.ICON_GRAY};
    border-radius: ${Radius.BUTTON};
    transition: border-color ${Transition.BUTTON};

    &:hover {
        border-color: ${Color.ICON_GRAY_HOVER};
    }

    &:focus {
        border-color: ${Color.BLACK};
    }

    &:disabled {
        color: ${Color.TEXT_GRAY};
        cursor: not-allowed;
    }
`;

const StyledField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

const StyledDoubleRow = styled.div`
    display: flex;
    gap: 8px;
`;

const StyledDoubleRowItem = styled.div`
    flex-grow: 1;
    flex-basis: 100%;

    button {
        width: 100%;
    }
`;

const StyledCustomSelect = styled(Select)`
    &&& {
        padding: 11px 14px;
        font-weight: 400;
        font-size: 13px;
        line-height: 1;
        color: ${Color.BLACK};
        background-color: ${Color.WHITE};
        border: 1px solid ${Color.ICON_GRAY};
        border-radius: ${Radius.BUTTON};
        transition: border-color ${Transition.BUTTON};

        &:hover {
            border-color: ${Color.ICON_GRAY_HOVER};
        }

        &:focus {
            border-color: ${Color.BLACK};
        }

        .react-dropdown-select-content {
            align-items: center;
        }

        .react-dropdown-select-dropdown {
            border: 1px solid ${Color.ICON_GRAY};
        }

        .react-dropdown-select-item {
            padding: 8px 14px;
            border-bottom: none;
            transition: background-color ${Transition.BUTTON};

            &:not(.react-dropdown-select-item-selected) {
                &:hover,
                &:focus {
                    background-color: ${Color.GRAY_BLUE_HOVER};
                }
            }
        }

        .react-dropdown-select-item-selected {
            color: ${Color.WHITE};
            background-color: ${Color.PRIMARY_BLUE};
        }
    }
`;

const StyledWrapperRadio = styled.label`
    display: flex;
    align-items: center;

    & .custom-radio-btn {
        position: relative; /* Родительский элемент*/
        display: inline-block; /* Для применения рамок, размеров*/
        width: 19px;
        height: 19px;
        background: #fff;
        border: 2px solid ${Color.PRIMARY_BLUE}; /* Толщина, стиль, цвет рамки*/
        border-radius: 50%; /* Получение круга*/
        vertical-align: text-top; /* Выравнивание кнопки по центру*/
        margin-right: 12px; /* Отступ между кнопкой и меткой*/

        &::before {
            content: '';
            display: inline-block;
            width: 13px;
            height: 13px;
            background: ${Color.PRIMARY_BLUE};
            border-radius: 50%;

            /* Выравниваем по центру относительно внешнего круга */
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%) scale(0);

            /* Плавный переход трансформации масштабирования */
            transition: 0.2s ease-in;
        }
    }

    & .real-radio-btn:checked + .custom-radio-btn::before {
        transform: translate(-50%, -50%) scale(1);
    }

    .real-radio-btn {
        /* Скрываем реальную радио кнопку*/
        width: 0;
        height: 0;
        position: absolute;
        opacity: 0;
        z-index: -1;
    }
`;

const StyledBoldText = styled.span`
    color: #303983;
    font-family: 'HelveticaNeueCyr';
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    margin: 0;
    line-height: 120%;
`;

export {
    StyledField as Field,
    StyledLabel as Label,
    StyledLabelTip as LabelTip,
    StyledInput as Input,
    StyledWrapperRadio as RadioBlock,
    StyledTextarea as Textarea,
    StyledDoubleRow as DoubleRow,
    StyledDoubleRowItem as DoubleRowItem,
    StyledCustomSelect as CustomSelect,
    StyledBoldText as SmallBoldText,
};
